import { useHistory } from "react-router"

export const useNavigate = () => {
    const history = useHistory();

    return { navigate: (path: string) => history.push(path) }
}